import LocalizeTextField from 'Engine/base/localization/LocalizeTextField';

export default class ControllerTextField extends LocalizeTextField{
  fitSize() {
    super.fitSize(true, true);
  }
}
